<template>
  <div>
    <router-view/>
    <Footerview />
  </div>
</template>

<script>
  import Footerview from './components/Footer.vue';

  export default {
    components: {
      Footerview
    }
  }
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Lobster&family=Lora:wght@400;500;600&family=Outfit:wght@400;700&family=Poppins:wght@100;300;400;500;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lobster&family=Lora:wght@400;500;600&family=Outfit:wght@400;700&family=Poppins:wght@100;300;400;500;600;700&display=swap");

 * {
  font-family: 'Poppins', sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
  outline: none;
  border: none;
}
html {
  font-size: 62.5%;
  overflow-x: hidden;
}
html::-webkit-scrollbar {
  width: 1rem;
}
html::-webkit-scrollbar-track {
  background-color: #0d0d0d;
}
html::-webkit-scrollbar-thumb {
  background-color: crimson;
  border-radius: 5rem;
}
body {
  background-color: #0d0d0d;
  padding-bottom: 6.5rem;
}
@media (max-width: 450px) {
  html {
    font-size: 50%;
  }
}
a {
  cursor: pointer;
}
</style>
